import styled from 'styled-components';

export const HeaderContent = styled.div`
	display: flex;
	align-items: center;
	gap: 1rem;
`;

export const Legend = styled.div`
	display: flex;
	align-items: center;
	gap: 0.75rem;
`;

export const LegendItem = styled.div`
	display: flex;
	align-items: center;
	gap: 0.35rem;
`;

export const LegendSwatch = styled.span<{ $variant: 'bound' | 'unbound' }>`
	display: inline-block;
	width: 0.75rem;
	height: 0.75rem;
	border-radius: 2px;
	border: 2px ${({ $variant }) => ($variant === 'bound' ? 'solid' : 'dashed')}
		${({ $variant, theme }) =>
			$variant === 'bound' ? theme.v3.colors.blue[4] : theme.v3.colors.gray[6]};
	background-color: ${({ $variant, theme }) =>
		$variant === 'bound' ? theme.v3.colors.blue[0] : theme.v3.colors.gray[2]};
`;

export const ToggleRow = styled.div`
	display: grid;
	grid-template-columns: 1fr auto 1fr;
	align-items: center;
	gap: 0.75rem;
	/* No horizontal padding: the "Preview as" pill sits flush with the row's
	   right edge so it lines up with the canvas/panel edges below it. */
	padding: 0.25rem 0;
`;

// Third grid cell when there is no "Preview as" pill — pinned right so a
// caller-supplied control lines up with the panel edge below it.
export const HeaderActionSlot = styled.div`
	justify-self: end;
`;

// The "Preview as <investor>" pill: a single rounded, outlined container that
// wraps a static label and the (borderless) investor Select so the two read as
// one control. `justify-self: end` sizes it to its content and pins it to the
// far-right grid column (the toggle stays centred in the middle column).
export const PreviewAsPill = styled.div`
	justify-self: end;
	display: flex;
	align-items: center;
	gap: 0.35rem;
	padding-left: 0.85rem;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[3]};
	border-radius: 999px;
	background-color: #fff;
	/* Clip the inner (rectangular) Select background to the pill's rounded
	   corners so its white corners don't poke past the border. */
	overflow: hidden;
`;

export const ShortcutHint = styled.span`
	display: inline-flex;
	align-items: center;
	gap: 0.15rem;
`;

export const ShortcutKey = styled.span`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-width: 1.05rem;
	height: 1.05rem;
	padding: 0 0.2rem;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[3]};
	border-radius: 4px;
	background-color: ${({ theme }) => theme.v3.colors.gray[0]};
	color: ${({ theme }) => theme.v3.colors.gray[9]};
	font-size: 0.7rem;
	line-height: 1;
`;

// `$singleColumn`: the side panel is gone in preview mode, so the canvas takes the whole width
// rather than leaving a 440px gap where it was.
export const Split = styled.div<{ $singleColumn?: boolean }>`
	display: grid;
	grid-template-columns: ${({ $singleColumn }) =>
		$singleColumn ? 'minmax(0, 1fr)' : 'minmax(0, 1fr) 440px'};
	grid-template-rows: minmax(0, 1fr);
	gap: 1rem;
	flex: 1;
	min-height: 0;
	/* A fixed viewport for its two independently-scrolling columns: without this the
	   columns grow to their content and the whole page scrolls instead. */
	overflow: hidden;
`;

// The only scroller for the pages; the side panel beside it stays put.
export const CanvasPane = styled.div`
	min-width: 0;
	min-height: 0;
	height: 100%;
	overflow: auto;
	display: flex;
	flex-direction: column;
`;

export const SidePanel = styled.div`
	display: flex;
	flex-direction: column;
	min-height: 0;
	height: 100%;
	gap: 0.5rem;
`;

// Bounds BindPanel to the remaining space above the footer, giving its own
// `height: 100%` / internal flex chain a definite height to resolve against so
// its ScrollBody actually scrolls. Taking `flex: 1` here is also what keeps the
// Save/Discard footer — a sibling below, deliberately outside this scroll
// region — pinned to the bottom of the column.
export const BindPanelSlot = styled.div`
	flex: 1;
	min-height: 0;
`;
